<div class="palantir-checkbox">
  <palantir-icon name="check-outline" role="check" />
  <palantir-icon name="indeterminate-outline" role="indeterminate" />
</div>

@if (label) {
  <palantir-text type="text">{{ label }}</palantir-text>
}
